export default (type) =>
  ({ modal }) => {
    const props = {
      modalOpen: modal && modal.type === type,
    };

    if (props.modalOpen) {
      return { ...props, ...modal.initialValue };
    }

    return props;
  };
